import { createActionGroup } from '@ngrx/store';

export const InstituteAPIActions = createActionGroup({
  source: 'Institute API',
  events: {},
});
